import { stationConfigurationsTypes } from "redux/reducers/stationConfigurations/types";

const {
    SET_STATION_CONFIGURATIONS_FILTERS,
    CLEAR_STATION_CONFIGURATIONS,
} = stationConfigurationsTypes

export const clearStationConfigurations = () => ({
    type: CLEAR_STATION_CONFIGURATIONS,
})

export const setStationConfigurationsFilters = (key = "", data) => ({
    type: SET_STATION_CONFIGURATIONS_FILTERS,
    payload: { data, key }
})